import {Injectable} from '@angular/core';
import {HttpClient } from '@angular/common/http';
import {Observable} from "rxjs";
import {FrequencyStatus} from "./frequencyStatus";
import {UrlBuilder} from "../url-builder/url.builder";



@Injectable({
  providedIn: 'root'
})
export class FrequencyStatusDataservice {

  private uiUrl: string = "";
  private url: UrlBuilder;

  constructor(private http: HttpClient) {
    this.url = new UrlBuilder();
  }


  GetData(): Observable<FrequencyStatus> {
    this.uiUrl = this.url.GetFrequencyUrl();
    console.log('FILE: ' + this.uiUrl);
    return this.http.get<FrequencyStatus>(this.uiUrl);
  }

}


